export const categories = [
  { id: "all", label: "All work", default: true, catchAll: true },
  { id: "featured", label: "Featured work" },
  { id: "selected", label: "Selected projects" },
  { id: "experiments", label: "Experiments" },
  { id: "credentials", label: "Credentials" },
];
